import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLocation, deleteParty } from "../../api/inventory";
import { Fragment } from "react";
import { useSetRecoilState } from "recoil";
import {
  locationPartyEditIdState,
  locationPartyEditState,
  toastBgState,
  toastMessageState,
  toastShowState,
} from "../../utils/atoms/atoms";

interface ILocationPartyEditDeleteButton {
  part_id: number;
  btnType: "edit" | "delete";
  isLocation: boolean;
}
const LocationPartyEditDeleteButton = ({
  part_id,
  btnType,
  isLocation = false,
}: ILocationPartyEditDeleteButton) => {
  const queryClient = useQueryClient();

  const isEdit = btnType === "edit";
  const setLocPartyEditIdState = useSetRecoilState(locationPartyEditIdState);
  const setLocPartyEditState = useSetRecoilState(locationPartyEditState);
  const setToastShow = useSetRecoilState(toastShowState);
  const setToastBg = useSetRecoilState(toastBgState);
  const setToastMessage = useSetRecoilState(toastMessageState);

  const deleteLocPartyMutation = useMutation({
    mutationFn: async (id: number) => {
      return isLocation ? deleteLocation(id) : deleteParty(id);
    },
    onSuccess(data) {
      if (isLocation) {
        queryClient.invalidateQueries(["location"]);
      } else {
        queryClient.invalidateQueries(["parties"]);
      }
      setToastBg("success");
      setToastMessage(data.message);
      setToastShow(true);
    },
    onError(error: any) {
      setToastBg("danger");
      setToastMessage(error.response.data.error);
      setToastShow(true);
    },
  });

  return (
    <Fragment>
      <div
        className={`styled-btn--dark inv-${btnType}`}
        onClick={() => {
          if (isEdit) {
            setLocPartyEditIdState(part_id);
            setLocPartyEditState(isLocation ? "location" : "party");
          } else {
            confirm("are you sure?")
              ? deleteLocPartyMutation.mutate(part_id)
              : "";
          }
        }}
      >
        <div>
          <i
            className={isEdit ? "bi bi-pencil-square" : "bi bi-trash3-fill"}
          ></i>
        </div>
      </div>
    </Fragment>
  );
};

export default LocationPartyEditDeleteButton;
